<template>
  <v-container>
    <PageHeader :title="name" />

    <v-form ref="form" style="width: 100%">
      <v-card>
        <Subheader title="Tenant and Project Names" no-search></Subheader>
        <v-progress-linear v-if="isLoading" :indeterminate="true"></v-progress-linear>
        <v-layout row wrap v-if="!isLoading"></v-layout>
        <v-card-text>
          <v-layout row wrap v-if="!isLoading">
            <template v-for="reportObj in reportObjects">
              <v-flex xs12 md10 offset-md1 :key="reportObj.configKey">
                <v-layout row wrap align-center>
                  <v-flex xs8>
                    <span style="align-self: center">{{ reportObj.display }}</span>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox v-model="activatedReportsForm[reportObj.configKey]"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
            <v-flex xs12 md4 offset-md4 pl-1 pr-1>
              <v-btn color="success" block @click="handleSave">
                <v-icon class="mr-1">done</v-icon>
                {{ $t('Button.Save') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { UiConfigKeys } from '@/store/UI/uiconfig'
  import { reportTypes } from '@/store/stations'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'

  const uiConfig = createNamespacedHelpers('uiconfig')
  export default {
    components: {
      ErrorDialog,
    },
    mixins: [SnackBarUtil],
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        isLoading: false,
        activatedReports: {},
        activatedReportsForm: {},
        tenantUiConfigOptions: {},
      }
    },
    computed: {
      reportObjects() {
        return Object.keys(reportTypes).map(k => reportTypes[k])
      },
      formConfigOptions() {
        let data = []
        Object.keys(this.activatedReportsForm).forEach(k => {
          if (this.activatedReportsForm[k]) {
            data.push(k)
          }
        })
        return data
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    watch: {
      tenantUiConfigOptions() {
        if (!this.tenantUiConfigOptions) {
          return
        }
        let reportConfigs = this.tenantUiConfigOptions.find(
          x => x.Key === UiConfigKeys.ReportComponentVisibility
        )
        let activatedReports = reportConfigs ?
          JSON.parse(reportConfigs.Value) : []
        this.setForm(activatedReports)
      },
      activatedReports() {
        this.activatedReportsForm = this.activatedReports
      },
    },
    methods: {
      ...uiConfig.mapActions([
        'getUiConfigOptions',
        'putUiConfigOptionArray',
      ]),
      initForm() {
        let reportsInput = {}
        this.reportObjects.forEach(obj => {
          reportsInput[obj.configKey] = false
        })
        this.activatedReports = reportsInput
      },
      setForm(data) {
        this.reportObjects.forEach(obj => {
          this.activatedReports[obj.configKey] = data.includes(
            obj.configKey
          )
        })
      },
      handleSave() {
        let data = [{
          Key: UiConfigKeys.ReportComponentVisibility,
          Value: JSON.stringify(this.formConfigOptions),
        }]
        this.putUiConfigOptions(data)
      },
      fetchUiConfigOptions() {
        let that = this
        let options = {
          config: { params: { tenant: that.name } },
          successCb(data) {
            that.initForm()
            that.tenantUiConfigOptions = data
            that.isLoading = false
          },
          failedCb: (msg) => {
            console.error(msg)
            that.isLoading = false
            this.$store.dispatch('app/setErrorDialog', {
              data: `Failed to fetch options: ${msg}`,
              title: '',
              show: true,
            })
          },
        }
        this.isLoading = true
        this.getUiConfigOptions(options)
      },
      putUiConfigOptions(configOptions) {
        let that = this
        let options = {
          data: configOptions,
          config: { params: { tenant: that.name } },
          update: true,
          successCb() {
            that.isLoading = false
            that.handleNotification({
              type: 'success',
              message: 'Successfully updated configurations',
            })
          },
          failedCb: (msg) => {
            console.error(msg)
            that.isLoading = false
            this.$store.dispatch('app/setErrorDialog', {
              data: `Failed to update configurations: ${msg}`,
              title: '',
              show: true,
            })
          },
        }
        this.isLoading = true
        this.putUiConfigOptionArray(options)
      },
    },
    mounted() {
      this.fetchUiConfigOptions()
    },
  }
</script>